import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MenuBulletHorizontal = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g fillRule="evenodd">
        <g>
          <path
            d="M8 6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM2 6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm12 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
            transform="translate(-1356.000000, -1286.000000) translate(1356.000000, 1286.000000)"
          />
        </g>
      </g>
    </svg>
  );
};

MenuBulletHorizontal.displayName = 'MenuBulletHorizontal';
